// Mock data for Taylormade Cleaning Service

export const services = [
  {
    id: 1,
    title: "Residential Cleaning",
    description: "Complete home cleaning services tailored to your needs. From regular maintenance to deep cleaning, we keep your home spotless.",
    icon: "Home",
    features: ["Regular cleaning schedules", "Customizable service plans", "Eco-friendly products", "Background-checked staff"],
    image: "https://images.pexels.com/photos/6196694/pexels-photo-6196694.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Commercial Cleaning",
    description: "Professional cleaning solutions for offices, retail spaces, and commercial properties. Maintain a pristine business environment.",
    icon: "Building2",
    features: ["After-hours service available", "Customized cleaning plans", "Professional equipment", "Experienced team"],
    image: "https://images.pexels.com/photos/6195129/pexels-photo-6195129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Deep Cleaning",
    description: "Thorough, intensive cleaning that reaches every corner. Perfect for seasonal refreshes or special occasions.",
    icon: "Sparkles",
    features: ["Detailed cleaning checklist", "Hard-to-reach areas", "Appliance cleaning", "Floor and carpet care"],
    image: "https://images.pexels.com/photos/5591926/pexels-photo-5591926.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 4,
    title: "Move-In/Move-Out",
    description: "Make your transition smooth with our comprehensive move-in and move-out cleaning services.",
    icon: "TruckIcon",
    features: ["Full property cleaning", "Cabinet and closet cleaning", "Window and blind cleaning", "Flexible scheduling"],
    image: "https://images.pexels.com/photos/4239037/pexels-photo-4239037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 5,
    title: "Air BnB Cleaning",
    description: "Fast, reliable turnover cleaning for your short-term rental properties. Keep your guests happy and reviews stellar.",
    icon: "Hotel",
    features: ["Quick turnaround times", "Linen service available", "Guest-ready standards", "Same-day availability"],
    image: "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27"
  },
  {
    id: 6,
    title: "Post Construction Cleaning",
    description: "Specialized cleaning after construction or renovation projects. Remove dust, debris, and prepare your space for use.",
    icon: "HardHat",
    features: ["Construction debris removal", "Dust and residue elimination", "Window and fixture cleaning", "Final touch detailing"],
    image: "https://images.pexels.com/photos/6195114/pexels-photo-6195114.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 7,
    title: "Retail Store Cleaning",
    description: "Keep your retail space inviting and spotless for customers. Regular cleaning to maintain your brand image.",
    icon: "ShoppingBag",
    features: ["Daily or weekly schedules", "Display and shelf cleaning", "Floor maintenance", "Restroom sanitization"],
    image: "https://images.pexels.com/photos/6196566/pexels-photo-6196566.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 8,
    title: "Gym Cleaning",
    description: "Specialized cleaning and sanitization for fitness centers. Keep equipment and facilities hygienic for members.",
    icon: "Dumbbell",
    features: ["Equipment sanitization", "Locker room cleaning", "Floor disinfection", "High-touch surface focus"],
    image: "https://images.unsplash.com/photo-1758273705723-26ef454252ce"
  },
  {
    id: 9,
    title: "Warehouse Cleaning",
    description: "Industrial-grade cleaning for warehouses and storage facilities. Maintain safety and efficiency standards.",
    icon: "Warehouse",
    features: ["Large-area floor cleaning", "Industrial equipment", "Safety-compliant methods", "Flexible scheduling"],
    image: "https://images.pexels.com/photos/6195129/pexels-photo-6195129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 10,
    title: "Restaurant Cleaning",
    description: "Professional kitchen and dining area cleaning to meet health code standards. Keep your establishment pristine.",
    icon: "UtensilsCrossed",
    features: ["Kitchen deep cleaning", "Grease removal", "Health code compliance", "After-hours service"],
    image: "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Homeowner",
    content: "Taylormade has been cleaning my home for over a year now. They're reliable, thorough, and always professional. I highly recommend them!",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    role: "Office Manager",
    content: "Our office has never looked better. The team is discreet, efficient, and does an excellent job. Great value for the quality of service.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Williams",
    role: "Air BnB Host",
    content: "As an Air BnB host, quick turnarounds are crucial. Taylormade always delivers on time and my guests consistently comment on how clean the property is.",
    rating: 5
  },
  {
    id: 4,
    name: "Michael Roberts",
    role: "Property Manager",
    content: "Professional, dependable, and detail-oriented. Taylormade handles all our move-out cleanings and they're always thorough.",
    rating: 5
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.pexels.com/photos/6196694/pexels-photo-6196694.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "residential",
    title: "Living Room Cleaning"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/6195129/pexels-photo-6195129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "commercial",
    title: "Professional Team"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27",
    category: "residential",
    title: "Sparkling Clean Home"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1758273705723-26ef454252ce",
    category: "deep",
    title: "Detailed Cleaning"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/5591926/pexels-photo-5591926.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "deep",
    title: "Kitchen Deep Clean"
  },
  {
    id: 6,
    url: "https://images.pexels.com/photos/4239037/pexels-photo-4239037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "residential",
    title: "Bathroom Cleaning"
  },
  {
    id: 7,
    url: "https://images.pexels.com/photos/6195114/pexels-photo-6195114.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "restaurant",
    title: "Commercial Kitchen"
  },
  {
    id: 8,
    url: "https://images.pexels.com/photos/6196566/pexels-photo-6196566.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "residential",
    title: "Floor Care"
  },
  {
    id: 9,
    url: "https://images.unsplash.com/photo-1594159855327-c8c0842a2132?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "commercial",
    title: "Office Space Cleaning"
  },
  {
    id: 10,
    url: "https://images.unsplash.com/photo-1578874691223-64558a3ca096?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "gym",
    title: "Gym Equipment Sanitization"
  },
  {
    id: 11,
    url: "https://images.pexels.com/photos/4716814/pexels-photo-4716814.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "gym",
    title: "Fitness Center Cleaning"
  },
  {
    id: 12,
    url: "https://images.unsplash.com/photo-1634586648651-f1fb9ec10d90?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "construction",
    title: "Post-Construction Cleanup"
  },
  {
    id: 13,
    url: "https://images.unsplash.com/photo-1592414744366-9ced52b9dab0?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "construction",
    title: "Renovation Clean-Up"
  },
  {
    id: 14,
    url: "https://images.pexels.com/photos/8629124/pexels-photo-8629124.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "restaurant",
    title: "Restaurant Kitchen Sanitization"
  },
  {
    id: 15,
    url: "https://images.unsplash.com/photo-1663790776790-680c6282da2d?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "restaurant",
    title: "Commercial Kitchen Cleaning"
  },
  {
    id: 16,
    url: "https://images.pexels.com/photos/5779776/pexels-photo-5779776.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "restaurant",
    title: "Food Service Cleaning"
  },
  {
    id: 17,
    url: "https://images.pexels.com/photos/6998627/pexels-photo-6998627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "commercial",
    title: "Sanitizing & Disinfecting"
  },
  {
    id: 18,
    url: "https://images.pexels.com/photos/4099467/pexels-photo-4099467.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "moveout",
    title: "Move-Out Cleaning"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What areas do you serve?",
    answer: "We proudly serve Lexington, KY and surrounding cities."
  },
  {
    id: 2,
    question: "Are your cleaners background-checked?",
    answer: "Yes, all our team members undergo thorough background checks and are fully trained professionals."
  },
  {
    id: 3,
    question: "Do you bring your own cleaning supplies?",
    answer: "Yes, we provide all necessary cleaning supplies and equipment. We use eco-friendly products that are safe for your family and pets."
  },
  {
    id: 4,
    question: "How do I get a quote?",
    answer: "You can request a free quote through our online form, and we'll get back to you within 24 hours with a customized estimate."
  },
  {
    id: 5,
    question: "Can I schedule recurring cleanings?",
    answer: "Absolutely! We offer flexible scheduling options including weekly, bi-weekly, and monthly recurring services."
  }
];
